<div class="account-access">
  <a class="account-profile" routerLink="/profile" (click)="profileOpened.emit()"
    [attr.aria-label]="'Abrir perfil de ' + user().nombre" [title]="user().nombre">
    <span class="account-avatar" aria-hidden="true"><span>{{ user().nombre.charAt(0) }}</span></span>
    <span class="account-copy">
      <span class="account-caption">Mi cuenta edil</span>
      <span class="account-name">{{ user().nombre }}</span>
    </span>
    <svg class="profile-arrow" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true"><path d="m9 5 7 7-7 7" /></svg>
  </a>
  <span class="account-divider" aria-hidden="true"></span>
  <button type="button" class="account-logout" (click)="signOut.emit()" aria-label="Cerrar sesión" title="Cerrar sesión">
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M9 4H5a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h4M14 8l4 4-4 4M8 12h13" /></svg>
    <span>Cerrar sesión</span>
  </button>
</div>
